import React, { useState } from "react";
// import axios from "axios";
import tscImage from "../../asset/images/tsc.jpg";
import { FiMapPin } from "react-icons/fi";
import "./VenuAccomodation.css";

const VenuAccomodation = () => {
  const staticAccommodations = [
    {
      _id: "accommodation-1",
      title: "Jashore University of Science and Technology (JUST) Campus",
      description: `The venue has a few arrangement of accommodations in it's Teachers' Students Centre (TSC). The TSC is a seven storied building. It has different categories of accommodations including non-AC and AC, single and double categories. The venue is fully visible from the top of the building. It contains dining rooms, meeting rooms, stages, a multipurpose hall, game rooms, and more. However, the number of accommodations is limitied and will be alloted on a first request first serve basis. Guests have to pay as per payment rules of the TSC. Guests have to pay for food if they order it from TSC. Please write to the conference secretary if you need accommodations.`,
      imageUrl: tscImage
    }
  ];

  const [accommodations] = useState(staticAccommodations);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  // useEffect(() => {
  //   const fetchAccommodations = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/accomodations`
  //       );
  //       setAccommodations(response.data.accommodations || []);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching accommodation details:", error);
  //       setError("Error loading accommodation information");
  //       setLoading(false);
  //     }
  //   };

  //   fetchAccommodations();
  // }, []);

  return (
    <div className="venue-accommodation-container">
      <div className="heading-container">
        <h4>Accommodations</h4>
      </div>

      <div className="venue-accommodation-content">
        {accommodations.length > 0 ? (
          accommodations.map((accommodation) => (
            <div key={accommodation._id} className="venue-accommodation-layout">
                {/* Left Side - Image and Map */}
                <div className="venue-left-section">
                  {accommodation.imageUrl && (
                    <div className="venue-image-wrapper">
                      <img
                        src={accommodation.imageUrl}
                        alt={accommodation.title}
                        className="venue-image"
                      />
                    </div>
                  )}
                  
                  <div className="venue-map-wrapper">
                    <div className="map-header">
                      <FiMapPin className="map-icon" />
                      <h5>Location Map</h5>
                    </div>
                    <div className="map-container">
                      <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.2652049214375!2d89.1254175!3d23.2334345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ff1857827d6cb7%3A0xecab69d917b1a29b!2sJashore%20University%20of%20Science%20and%20Technology!5e0!3m2!1sen!2sbd!4v1766255183705!5m2!1sen!2sbd" 
                        width="100%" 
                        height="100%" 
                        style={{border: 0}} 
                        allowFullScreen="" 
                        loading="lazy" 
                        referrerPolicy="no-referrer-when-downgrade"
                        title="JUST Location Map"
                      />
                    </div>
                  </div>
                </div>

                {/* Right Side - Details */}
                <div className="venue-right-section">
                  <div className="venue-details-card">
                    <h3 className="venue-title">{accommodation.title}</h3>
                    <div className="venue-description">
                      <p>{accommodation.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-data">No accommodation details available</div>
          )}
        </div>
    </div>
  );
};

export default VenuAccomodation;